// .gitignore this file
// sensitive info

export const token =  '6f3fc64d43f84462a54f311eeaefa6f2';



//////////////////
// WEBPACK FOOTER
// ./.config.js
// module id = null
// module chunks = 